import React, { createContext } from 'react';
import useModal from '@hooks/useModal';
 
import Modal from './Modal';

type UseModalResult = ReturnType<typeof useModal>;

const defaultContext: UseModalResult = {
  closeModal: () => {
    /**/
  },
  openModal: () => {
    /**/
  },
  requestClose: () => {
    /**/
  },
  fullscreen: false,
  open: false,
  content: <div />,
  disableQuickClose: false,
  setDisableQuickClose: () => {
    /**/
  },
  showCloseConfirmation: false,
  cancelCloseConfirmation: () => {
    /**/
  },
};

const ModalContext = createContext<UseModalResult>(defaultContext);
const { Provider } = ModalContext;

function ModalProvider({ children }: Readonly<{ children: React.ReactNode }>) {
  const context = useModal();
  return (
    <Provider value={context}>
      <Modal />
      {children}
    </Provider>
  );
}

export { ModalContext, ModalProvider };
